import { useCallback, useMemo } from 'react';

import { useOnChangeGlobalContext } from '../components/GlobalContext';

export const useChatUrlParam = (): [
    boolean,
    {
        setUrlParam: (value: boolean) => void;
    }
] => {
    const { router } = useOnChangeGlobalContext();

    const getChatParam = useCallback((): boolean => {
        const searchParams = new URLSearchParams(router.location.search);

        return searchParams.get('chat') === 'true';
    }, [ router.location.search ]);

    const chatParam = useMemo(() => getChatParam(), [ getChatParam ]);

    const setUrlParam = useCallback((value: boolean) => {
        const currentUrl = new URL(router.currentUrl);

        if (value) {
            currentUrl.searchParams.set('chat', 'true');
        } else {
            currentUrl.searchParams.delete('chat');
        }

        router.update(currentUrl.pathname + currentUrl.search, { replace: true });
    }, [ router ]);

    return [ chatParam, { setUrlParam } ];
};

